import { render, staticRenderFns } from "./UserPhoneWrongDetail.vue?vue&type=template&id=223a5f9f&scoped=true&"
import script from "./UserPhoneWrongDetail.vue?vue&type=script&lang=js&"
export * from "./UserPhoneWrongDetail.vue?vue&type=script&lang=js&"
import style0 from "./UserPhoneWrongDetail.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./UserPhoneWrongDetail.vue?vue&type=style&index=1&id=223a5f9f&scoped=true&lang=scss&"
import style2 from "./UserPhoneWrongDetail.vue?vue&type=style&index=2&lang=scss&"
import style3 from "./UserPhoneWrongDetail.vue?vue&type=style&index=3&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "223a5f9f",
  null
  
)

export default component.exports